module.exports = __webpack_public_path__ + "img/06-min.4e79268d.jpg";